import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'features/rootReducer';
import qs, { ParsedQs } from 'qs';
import { ReferralRevenueDetailFilter, ReferralRevenueDetailInfo } from 'types/marketplace/revenue';

interface ReferralDetailSliceState {
  filter?: ReferralRevenueDetailFilter;
  loading: boolean;
  data?: ReferralRevenueDetailInfo;
  error?: boolean;
}

const initialState: ReferralDetailSliceState = {
  loading: false,
};

export const referralDetailSlice = createSlice({
  name: 'referralDetail',
  initialState,
  reducers: {
    loadData: (state, { payload }: PayloadAction<ParsedQs>) => {
      const { startDate, endDate, storeTypes, userId } = payload;
      if (!startDate || !endDate || !storeTypes || !userId) {
        state.loading = false;
        return;
      } else {
        state.loading = true;
        state.data = undefined;
        state.filter = {
          startDate,
          endDate,
          storeTypes,
          userId,
        } as unknown as ReferralRevenueDetailFilter;
      }
    },
    loadDataSuccess: (state, { payload }: PayloadAction<ReferralRevenueDetailInfo>) => {
      state.loading = false;
      state.data = payload;
    },
    loadDataFailure: state => {
      state.loading = false;
      state.error = true;
    },
  },
});

export const referralDetailActions = referralDetailSlice.actions;
export const referralDetailReducer = referralDetailSlice.reducer;

export const selectReferralDetailError = (state: RootState) => state.referral.detail.error;
export const selectReferralDetailLoading = (state: RootState) => state.referral.detail.loading;
export const selectReferralDetailData = (state: RootState) => state.referral.detail.data;
export const selectReferralDetailQueryString = (state: RootState): string =>
  qs.stringify(state.referral.detail.filter, { arrayFormat: 'repeat' });
